module.exports = __webpack_public_path__ + "static/media/muncipal_tax.7a3eb979.svg";